module.exports = __webpack_public_path__ + "media/components/tide-table/static/moon-first-quarter-c29ef4583be700beedfd19fda8f0289a.svg";